import type { LuggageFilterValue } from '@/lib/schemas/flight-results-search.schema'

import { useFiltersState } from './filters-state-context'

interface UseLuggageFilterResult {
  setLuggage: (value: LuggageFilterValue) => void
  value: LuggageFilterValue | undefined
}

/**
 * Écriture du filtre « bagage en soute inclus », partagée par la sidebar
 * ({@link LuggageFilter}) et le CTA rapide de la barre mobile
 * ({@link BaggageQuickFilter}) — les deux pilotent le MÊME param d'URL.
 *
 * C'est un filtrage purement client, et ça n'a rien d'évident : demander 1 ou 2
 * bagages relançait auparavant une recherche complète avec `withLuggage`, parce
 * que le lot d'offres courant n'avait été cherché que sur un seul axe. La
 * recherche part désormais en deux exemplaires (avec et sans forçage bagage)
 * réunis côté serveur, donc la liste affichée contient déjà les deux mondes :
 * il n'y a plus rien à aller chercher.
 */
export function useLuggageFilter(): UseLuggageFilterResult {
  const {
    filters: { filterLuggage },
    setFilters,
  } = useFiltersState()

  const setLuggage = (value: LuggageFilterValue) => {
    setFilters({ filterLuggage: value })
  }

  return { setLuggage, value: filterLuggage }
}
